import NavSearch from "../Nav/NavSearch";
const Search=()=>{
  return(
    <>
  <NavSearch/>
    </>
    )
}
export default Search;